import { toast, Slide } from 'react-toastify';
import { COLORS } from '../colors';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';

const toggleToast = (message: string, status: 'success' | 'error') => {
  const color =
    status === 'success' ? COLORS.TOAST_SUCCESS : COLORS.TOAST_ERROR;
  toast(message, {
    position: 'top-right',
    autoClose: 4000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    type: status,
    transition: Slide,
    icon: false,
    style: {
      background: color,
      color: 'white',
      fontSize: '.875rem',
      fontFamily: 'Montserrat',
    },
    closeButton: ({ closeToast }) => (
      <button
        onClick={closeToast}
        style={{
          background: 'white',
          border: 'none',
          color: 'white',
          cursor: 'pointer',
          padding: '0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '1.5rem ',
          height: '1.5rem',
          margin: 'auto .5rem',
          borderRadius: '50%',
          opacity: '80%',
        }}>
        <CloseIcon sx={{ color: color, fontWeight: 600 }} />
      </button>
    ),
  });
};

export default toggleToast;
